import React from 'react';
import Form from 'rsuite/Form';
import IntlTelInput from "intl-tel-input/reactWithUtils";

export default function FieldText({
  name,
  label,
  accepter,
  required,
  phoneDisabled,
  phoneNotice,
  dataItiPhone,
  ...rest
}) {
  return (
    <Form.Group controlId={name} className="field">
      {label && (
        <Form.ControlLabel>
          {label}
          {required && (<sup>*</sup>)}
        </Form.ControlLabel>
      )}

      {/* iti validation */}
      {(dataItiPhone && !phoneDisabled) ? (
          <div className={`iti-wrapper-custom${phoneNotice ? " iti-wrapper-custom--error" : ""}`}>
          <IntlTelInput
              inputProps={{
                  maxLength: 20,
                  onKeyDown: (e) => {
                      if (!/[0-9()+\- .]/.test(e.key) && e.key.length === 1) {
                          e.preventDefault();
                      }
                  }
              }}
              accepter={accepter}
              name={name}
              data-iti-phone={dataItiPhone}
              {...rest}
          />
              <div className="input__text input__text--error">{phoneNotice}</div>

              <Form.Control
                  type="hidden"
                  accepter={accepter}
                  name={name}
                  size="lg"
                  {...rest}
              />
          </div>
      ) : (
        <Form.Control
          accepter={accepter}
          name={name}
          size="lg"
          {...rest}
        />
      )}

    </Form.Group>
  );
}
